import React from 'react';
import { Link } from 'react-router-dom';

function ScheduleSection({ upcomingEvents }) {
  // Filter to only show games
  const upcomingGames = upcomingEvents
    ? upcomingEvents.filter((event) => event.eventType === 'game')
    : [];

  return (
    <section className="py-12 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white">Upcoming Games</h2>
          <Link to="/schedule" className="text-yellow-400 hover:text-yellow-300 font-medium">
            Full Schedule →
          </Link>
        </div>

        {/* Mobile: Card Layout */}
        <div className="md:hidden space-y-4">
          {upcomingGames.map((game) => (
            <div key={game._id} className="bg-black rounded-lg border border-gray-800 p-4">
              <div className="flex justify-between items-start mb-3">
                <div className="text-sm text-gray-400">
                  {new Date(game.startDate).toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric',
                  })}
                </div>
                <div className="text-sm text-gray-400">
                  {new Date(game.startDate).toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                  })}
                </div>
              </div>

              <div className="mb-3">
                <div className="flex items-center justify-center text-center">
                  <span
                    className={`text-sm font-medium ${
                      game.isHomeGame ? 'text-yellow-500' : 'text-gray-400'
                    }`}
                  >
                    {game.isHomeGame ? 'BOMBARDIERS' : game.opponent}
                  </span>
                  <span className="mx-2 text-gray-400">vs</span>
                  <span
                    className={`text-sm font-medium ${
                      !game.isHomeGame ? 'text-yellow-500' : 'text-gray-400'
                    }`}
                  >
                    {!game.isHomeGame ? 'BOMBARDIERS' : game.opponent}
                  </span>
                </div>
              </div>

              <div className="flex justify-center items-center">
                <div className="text-sm text-gray-300 truncate">{game.location || 'TBD'}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: Table Layout */}
        <div className="hidden md:block bg-black rounded-lg border border-gray-800 overflow-hidden shadow-lg">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-800">
              <thead className="bg-gray-900">
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    Date
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    Time
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    Matchup
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-middle text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    Location
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-4 text-right text-xs font-medium text-gray-400 uppercase tracking-wider"
                  ></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800">
                {upcomingGames.map((game) => (
                  <tr key={game._id} className="hover:bg-gray-900">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                      {new Date(game.startDate).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                      })}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-white">
                      {new Date(game.startDate).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                      })}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <span
                          className={`text-sm font-medium ${
                            game.isHomeGame ? 'text-yellow-500' : 'text-gray-400'
                          }`}
                        >
                          {game.isHomeGame ? 'BOMBARDIERS' : game.opponent}
                        </span>
                        <span className="mx-2 text-gray-400">vs</span>
                        <span
                          className={`text-sm font-medium ${
                            !game.isHomeGame ? 'text-yellow-500' : 'text-gray-400'
                          }`}
                        >
                          {!game.isHomeGame ? 'BOMBARDIERS' : game.opponent}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 items-center whitespace-nowrap text-sm text-gray-300">
                      {game.location}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {upcomingGames.length === 0 && (
          <div className="bg-black p-8 rounded-lg text-center border border-gray-800">
            <p className="text-gray-400 text-lg">No upcoming games scheduled</p>
          </div>
        )}

        <div className="mt-8 text-center">
          <Link
            to="/schedule"
            className="bg-yellow-600 hover:bg-yellow-700 text-white px-6 py-3 rounded-md font-medium inline-block"
          >
            View Full Schedule
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ScheduleSection;
